import React from "react";
import { ReactComponent as PhotoIcon } from "../../inlineSvgs/discover.svg";
import { useSelector } from "react-redux";

const UserInfo = () => {
  const user = useSelector((state) => state.userReducer.user);

  return (
    <div className="user_info">
      <div className="user_info__photo">
        <PhotoIcon />
      </div>
      <div className="user_info__data">
        <div className="user_info__name">{`${user?.firstName} ${user?.lastName}`}</div>
        <div className="user_info__email">{user?.email}</div>
      </div>
    </div>
  );
};

export default UserInfo;
